import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../components/Input/Button/Button';

const SeeAllButton = ({ text, url, type, isSingleSearch }) => {
    if (isSingleSearch) return null;

    return (
        <div className="see-all row justify-content-center pt-3 pb-5">
            <div className="d-inline-block text-center">
                <a href={url}>
                    <Button
                        type="solid"
                        value={text}
                        qaAttr={type}
                        inputStyle="community"
                    />
                </a>
            </div>
        </div>
    );
};

export default SeeAllButton;

SeeAllButton.propTypes = {
    text: PropTypes.string,
    url: PropTypes.string,
    type: PropTypes.string,
    isSingleSearch: PropTypes.bool,
};

SeeAllButton.defaultProps = {
    text: null,
    url: null,
    type: null,
    isSingleSearch: false,
};
